import { useTranslation } from 'react-i18next';
import { FormErrors } from '@hp/ui';

/** Inline pre-submit validation block; renders nothing when there are no issues. */
export function ValidationErrors({ issues }: { issues: string[] }) {
  const { t } = useTranslation('projects');
  if (issues.length === 0) return null;
  return (
    <FormErrors>
      <strong>{t('validation.heading')}</strong>
      <ul className="bo-issue-list">
        {issues.map((issue) => (
          <li key={issue}>{issue}</li>
        ))}
      </ul>
    </FormErrors>
  );
}
